import axios from './axios';

const STARRED_API_BASE = '/starred-properties';

// Debounce map to prevent double calls per pin (React Strict Mode fix)
const pendingToggles = new Map();

export const getStarredProperties = async () => {
  try {
    const res = await axios.get(STARRED_API_BASE);
    return res.data;
  } catch (err) {
    console.error('❌ Error getting starred properties:', err);
    throw err;
  }
};

export const toggleStarProperty = async (pin) => {
  // If a toggle for this pin is already in flight, return that same promise
  if (pendingToggles.has(pin)) {
    console.log('🚫 Toggle already in flight for pin:', pin, '— skipping duplicate');
    return pendingToggles.get(pin);
  }

  const promise = axios
    .post(`${STARRED_API_BASE}/toggle`, { pin })
    .then((res) => res.data)
    .catch((err) => {
      console.error('❌ Error toggling star:', err);
      throw err;
    })
    .finally(() => {
      pendingToggles.delete(pin);
    });

  pendingToggles.set(pin, promise);
  return promise;
};

export const clearStarredProperties = async (userId) => {
  try {
    const res = await axios.delete(`${STARRED_API_BASE}/${userId}`);
    return res.data;
  } catch (err) {
    console.error('❌ Error clearing starred properties:', err);
    throw err;
  }
};